export function EmptyState({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-1 p-8 text-center">
      <p className="text-sm font-medium text-muted">{title}</p>
      <p className="max-w-xs text-xs text-faint">{description}</p>
    </div>
  );
}
